import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  emptyView: {
    height: '50vh',
    minHeight: '300px',
  },
});
